import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as HomeOwnerActionTypes from './constants';
import * as NotifyActionType from 'Notification/constants';
import {
  getHomeOwnerList,
  editHomeOwnerInfo,
  getSelectListHomeowner,
  searchCurrentAssignedLot,
  getHomeOwnerProfile
} from './api';
import { sendAjaxRequest } from '../helper/interceptors';
import { AppSettings } from '../constants';

export function* getHomeOwnerListAsync(action) {

  const result = yield call(getHomeOwnerList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: HomeOwnerActionTypes.GET_HOME_OWNER_LIST_SUCCESS, data: {data: result.data, params: action.params.data} });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* editHomeOwnerInfoAsync(action) {

  const result = yield call(editHomeOwnerInfo, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' });
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield [
      put({ type: HomeOwnerActionTypes.EDIT_HOME_OWNER_INFO_FAIL, data: result.data})
    ];
  }
}

export function* getSelectListHomeownerAsync(action) {

  const result = yield call(getSelectListHomeowner, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: HomeOwnerActionTypes.GET_SELECT_LIST_HOMEOWNER_SUCCESS, data: result.data });
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data })
    ];
  }
}

export function* searchAssignedLotAsync(action) {

  const result = yield call(searchCurrentAssignedLot, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    let type = '';
    if (action.params.param.Type === 1) {
      type = HomeOwnerActionTypes.SEARCH_CURRENT_ASSIGNED_LOT_SUCCESS;
    } else if (action.params.param.Type === 2) {
      type = HomeOwnerActionTypes.SEARCH_FORMER_ASSIGNED_LOT_SUCCESS;
    } else if (action.params.param.Type === 3) {
      type = HomeOwnerActionTypes.SEARCH_TENANCY_ASSIGNED_LOT_SUCCESS;
    }
    yield put({
      type,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data })
    ];
  }
}

export function* getHomeOwnerProfileAsync(action) {

  const result = yield call(getHomeOwnerProfile, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: HomeOwnerActionTypes.GET_HOMEOWNER_PROFILE_SUCCESS, data: result.data });
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data })
    ];
  }
}
export function* resendActiveEmailBuilderAsync(action) {
  console.log(action, 'resendActiveEmailBuilderAsync')
  const result = yield call(
    sendAjaxRequest,
    AppSettings.SITE_ONE_SERVICE_URI,
    '/api/clients/resend-active-email/',
    action.params.data,
    'POST'
  );

  const statusCode = result.statusCode;
  console.log(statusCode, ' result.statusCode')

  if (statusCode === 200) {
    yield [
      put({
        type: HomeOwnerActionTypes.SEARCH_HOME_OWNER_SUCCESS,
        payload: { params: action.payload.params.search }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Email sent' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
export default function* WatchHomeOwner() {
  yield all([
    takeLatest(HomeOwnerActionTypes.GET_HOME_OWNER_LIST_ASYNC, getHomeOwnerListAsync),
    takeLatest(HomeOwnerActionTypes.EDIT_HOME_OWNER_INFO_ASYNC, editHomeOwnerInfoAsync),
    takeLatest(HomeOwnerActionTypes.GET_SELECT_LIST_HOMEOWNER_ASYNC, getSelectListHomeownerAsync),
    takeLatest(HomeOwnerActionTypes.SEARCH_CURRENT_ASSIGNED_LOT_ASYNC, searchAssignedLotAsync),
    takeLatest(HomeOwnerActionTypes.SEARCH_FORMER_ASSIGNED_LOT_ASYNC, searchAssignedLotAsync),
    takeLatest(HomeOwnerActionTypes.SEARCH_TENANCY_ASSIGNED_LOT_ASYNC, searchAssignedLotAsync),
    takeLatest(HomeOwnerActionTypes.GET_HOMEOWNER_PROFILE_ASYNC, getHomeOwnerProfileAsync),
    takeLatest(HomeOwnerActionTypes.SEARCH_HOME_OWNER_SUCCESS, resendActiveEmailBuilderAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/HomeOwners/saga.js